import { createFileRoute, redirect } from '@tanstack/react-router'
import { RecurringTransactionsPage } from '../pages/RecurringTransactionsPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/recurring-transactions' as any)({
    component: RecurringTransactionsPage,
    beforeLoad: () => {
        const { isAuthenticated } = useAuthStore.getState()
        if (!isAuthenticated) {
            throw redirect({
                to: '/login',
            })
        }
    },
})
